module.exports = __webpack_public_path__ + "img/40.1.b45cb40d.jpg";